import { usePaneRouterContextSafe } from "@/components/PaneRouter";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useRightPaneExpandContext } from "@/context/RightPaneExpandContext";
import { useBreakpoint } from "@/hooks/useBreakpoint";
import { Maximize2, Minimize2 } from "lucide-react";

export interface PaneExpandButtonProps {
  /** Optional class name for the button */
  className?: string;
}

export function PaneExpandButton({ className }: PaneExpandButtonProps) {
  const paneContext = usePaneRouterContextSafe();
  const { isExpanded, expandToMax, collapseToDefault } =
    useRightPaneExpandContext();
  const lg = useBreakpoint("lg");

  if (!lg || !paneContext) {
    return null;
  }

  const handleClick = () => {
    if (isExpanded) {
      collapseToDefault();
    } else {
      expandToMax();
    }
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="toolbarGhost"
            size="icon-sm"
            className={className}
            onClick={handleClick}
            aria-label={isExpanded ? "Collapse pane" : "Expand pane"}
          >
            {isExpanded ? <Minimize2 /> : <Maximize2 />}
          </Button>
        </TooltipTrigger>
        <TooltipContent>{isExpanded ? "Collapse" : "Expand"}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
